import {useAuthUser} from "@/features/identity/hooks/useAuthUser.ts";

export const useIsAuthenticated = () => {
    const {isAuthenticated} = useAuthUser();
    return isAuthenticated;
}